import React from 'react'
import { observer } from 'mobx-react-lite'

import { LoadOrdersForm } from './LoadOrdersForm'

import { useApi } from '../hooks/storeHook'
import { WbAccountProps } from '../types/accountProps'

export const WbLoadOrdersForm =
  observer(
    ({account}: WbAccountProps) => {
      const api = useApi()

      return <LoadOrdersForm accountId={account.id} loadOrders={api.userSync.loadWbOrders}/>
    })